import {
  IoWarningOutline,
  IoSearch,
  IoNotificationsOutline,
  IoLockClosedOutline,
  IoEyeOffOutline,
  IoEyeOutline,
  IoCartOutline,
  IoHomeOutline,
  IoHomeSharp,
  IoStorefrontOutline,
  IoStorefront,
  IoFilterCircleOutline,
  IoFilterCircle,
  IoFilterOutline,
  IoFilterSharp,
  IoAppsOutline,
  IoApps,
  IoEllipsisHorizontalOutline,
  IoAlertCircleOutline,
  IoMegaphoneOutline,
  IoMegaphone,
  IoBanOutline,
  IoSendOutline,
  IoChatboxEllipsesOutline,
  IoChatboxEllipses,
  IoCogOutline,
  IoCogSharp,
  IoCallOutline,
  IoCall,
  IoLocationOutline,
  IoLocateOutline,
  IoMailOutline,
  IoChevronForwardSharp,
  IoClose,
  IoEllipse,
  IoTodayOutline,
  IoColorFilterOutline,
  IoArrowRedoOutline,
  IoChevronDownSharp,
  IoChevronBackSharp,
  IoChevronUpSharp,
  IoMenu,
  IoCreate,
  IoCreateOutline,
  IoAddCircleOutline,
  IoRemoveCircleOutline,
  IoPencilOutline,
  IoTrashOutline,
  IoMoonOutline,
  IoSunnyOutline,
  IoGrid,
  IoGridOutline,
  IoExitOutline,
  IoPersonOutline,
  IoPerson,
  IoPeopleOutline,
  IoPeople,
  IoNotifications,
  IoCheckmark,
  IoCopy,
  IoCopyOutline,
  IoOpenOutline,
  IoCloudUploadOutline,
  IoShareOutline,
  IoTrailSignOutline,
  IoTrailSign,
  IoHeadsetOutline,
  IoHeadset,
  IoPersonAdd,
  IoImagesOutline,
  IoSaveOutline,
  IoLanguageOutline,
  IoTimeOutline,
  IoCloseCircleOutline,
  IoRefreshCircleOutline,
  IoRefresh,
  IoLogoUsd,
  IoPricetagOutline,
  IoPricetag,
  IoLogoApple,
  IoLogoBitcoin,
  IoLogoGoogle,
  IoLogoPaypal,
  IoCard,
  IoTrendingUp,
  IoSparkles,
  IoCart,
  IoColorFilterSharp,
  IoEllipsisHorizontalCircleOutline,
  IoWalletOutline,
  IoCarSportOutline,
  IoCarSport,
  IoDesktopSharp,
  IoPrintOutline,
  IoNewspaperOutline,
  IoLogoWhatsapp,
  IoStatsChartOutline,
  IoStatsChart,
  IoShirt,
  IoShirtOutline,
  IoImages,
  IoPricetagsOutline,
  IoPricetags,
  IoCheckmarkDoneCircleOutline,
  IoArrowForward,
  IoArrowDown,
  IoSwapHorizontalOutline,
  IoAddOutline,
  IoRemoveOutline,
  IoEllipseOutline,
  IoSwapVerticalOutline,
  IoDocumentOutline,
  IoRepeat,
  IoRepeatOutline,
  IoMaleSharp,
  IoFemale,
  IoList,
  IoPhonePortraitOutline,
  IoBusinessOutline,
  IoBusiness,
  IoCubeOutline,
  IoCube,
  IoLayersOutline,
  IoLayers,
  IoReceiptOutline,
  IoReceipt,
  IoBriefcaseOutline,
  IoBriefcase,
  IoArrowUndoOutline,
  IoShieldCheckmarkOutline,
  IoFlagOutline,
  IoCameraOutline,
  IoCardOutline,
  IoLinkOutline,
  IoBrushOutline,
  IoSquareOutline,
  IoExpandOutline,
  IoContractOutline,
} from 'react-icons/io5';
import { AiOutlineThunderbolt } from 'react-icons/ai';
import {
  PiCircuitryFill,
  PiUsersThreeLight,
  PiUsersThreeFill,
  PiCalendarBlankLight,
  PiCalendarBlankFill,
  PiFolderUserThin,
  PiFolderUserFill,
  PiTreeStructure,
} from 'react-icons/pi';
import {
  MdDragIndicator,
  MdFilterList,
  MdSettingsApplications,
  MdOutlineSettingsApplications,
} from 'react-icons/md';
import { TbPackages, TbPackageExport, TbSettingsAutomation, TbTruckDelivery, TbArrowsSort, TbCoin, TbTag, TbPlaneDeparture, TbBox, TbPackage } from 'react-icons/tb';
import {
  BiSolidCategoryAlt,
  BiCategoryAlt,
} from 'react-icons/bi';
import { FaMapLocationDot, FaFolderPlus, FaDrawPolygon, FaEraser } from 'react-icons/fa6';
import { SiStylelint } from 'react-icons/si';

import {
  RiUserSearchLine,
  RiUserSearchFill,
  RiTimeLine,
  RiTimeFill,
  RiSteering2Line,
  RiSteering2Fill,
} from 'react-icons/ri';

import {
  LuFolderPlus,
  LuPanelLeftClose,
  LuPanelLeftOpen,
  LuPanelRightClose,
  LuPanelRightOpen,
} from 'react-icons/lu';

export const Icons = {
  ErpFill: FaFolderPlus,
  Erp: LuFolderPlus,
  PIM: IoCubeOutline,
  PIMFill: IoCube,
  CMS: IoLayersOutline,
  CMSFill: IoLayers,
  OMS: IoReceiptOutline,
  OMSFill: IoReceipt,
  TimeOff: RiTimeLine,
  TimeOffFill: RiTimeFill,
  Recruitement: RiUserSearchLine,
  RecruitementFill: RiUserSearchFill,
  Attendance: PiFolderUserThin,
  AttendaceFill: PiFolderUserFill,
  Calendar: PiCalendarBlankLight,
  CalendarFill: PiCalendarBlankFill,
  HR: PiUsersThreeLight,
  HRFill: PiUsersThreeFill,
  Bolt: AiOutlineThunderbolt,
  Style: SiStylelint,
  Ai: PiCircuitryFill,
  Male: IoMaleSharp,
  Female: IoFemale,
  Map: FaMapLocationDot,
  Products: IoImagesOutline,
  ProductsFill: IoImages,
  Outfits: IoShirtOutline,
  OutfitsFill: IoShirt,
  Search: IoSearch,
  Forward: IoChevronForwardSharp,
  Back: IoChevronBackSharp,
  Up: IoChevronUpSharp,
  Down: IoChevronDownSharp,
  Cart: IoCartOutline,
  CartFill: IoCart,
  Show: IoEyeOutline,
  Hide: IoEyeOffOutline,
  Lock: IoLockClosedOutline,
  Plus: IoAddCircleOutline,
  Minus: IoRemoveCircleOutline,
  Warning: IoWarningOutline,
  Close: IoClose,
  CloseCircle: IoCloseCircleOutline,
  ReloadCircle: IoRefreshCircleOutline,
  Refresh: IoRefresh,
  Check: IoCheckmark,
  Menu: IoMenu,
  PanelLeftClose: LuPanelLeftClose,
  PanelLeftOpen: LuPanelLeftOpen,
  PanelRightClose: LuPanelRightClose,
  PanelRightOpen: LuPanelRightOpen,
  Date: IoTodayOutline,
  Share: IoArrowRedoOutline,
  CircleFill: IoEllipse,
  Post: IoCreateOutline,
  PostFill: IoCreate,
  Pencil: IoPencilOutline,
  Trash: IoTrashOutline,
  Sun: IoSunnyOutline,
  Moon: IoMoonOutline,
  Logout: IoExitOutline,
  Images: IoImagesOutline,
  Save: IoSaveOutline,
  Language: IoLanguageOutline,
  Cash: IoLogoUsd,
  Coin: TbCoin,
  Tag: TbTag,
  Apple: IoLogoApple,
  Bitcoin: IoLogoBitcoin,
  Google: IoLogoGoogle,
  Paypal: IoLogoPaypal,
  CreditCard: IoCard,
  Trend: IoTrendingUp,
  Best: IoSparkles,
  // bottom bar icons...
  Home: IoHomeOutline,
  HomeFill: IoHomeSharp,
  Store: IoStorefrontOutline,
  StoreFill: IoStorefront,
  Orders: IoFilterCircleOutline,
  OrdersFill: IoFilterCircle,
  Filter: IoFilterOutline,
  FilterFill: IoFilterSharp,
  Repeat: IoRepeat,
  Sections: IoAppsOutline,
  SectionsFill: IoApps,
  Grid: IoGridOutline,
  GridFill: IoGrid,
  List: IoList,
  ListViewFill: MdFilterList,
  Product: IoCopyOutline,
  ProductFill: IoCopy,
  Groups: IoColorFilterOutline,
  GroupsFill: IoColorFilterSharp,
  Group: IoPeopleOutline,
  GroupFill: IoPeople,
  AddPersonFill: IoPersonAdd,
  Person: IoPersonOutline,
  Offer: IoPricetagOutline,
  OfferFill: IoPricetag,
  PersonFill: IoPerson,
  Transaction: IoTrailSignOutline,
  TransactionFill: IoTrailSign,
  Support: IoHeadsetOutline,
  SupportFill: IoHeadset,
  More: IoEllipsisHorizontalOutline,
  About: IoAlertCircleOutline,
  Contact: IoChatboxEllipsesOutline,
  ContactFill: IoChatboxEllipses,
  Notifications: IoNotificationsOutline,
  NotificationsFill: IoNotifications,
  Settings: IoCogOutline,
  SettingsFill: IoCogSharp,
  AppSettings: MdOutlineSettingsApplications,
  AppSettingsFill: MdSettingsApplications,
  Time: IoTimeOutline,
  // about page icons...
  PhoneScreen: IoPhonePortraitOutline,
  Call: IoCallOutline,
  CallFill: IoCall,
  Whatsapp: IoLogoWhatsapp,
  Location: IoLocationOutline,
  Locate: IoLocateOutline,
  Mail: IoMailOutline,
  Menu3: IoEllipsisHorizontalCircleOutline,
  Wallet: IoWalletOutline,
  Car: IoCarSportOutline,
  CarFill: IoCarSport,
  Driver: RiSteering2Line,
  DriverFill: RiSteering2Fill,
  Monitor: IoDesktopSharp,
  Print: IoPrintOutline,
  Sheet: IoNewspaperOutline,
  Chart2: IoStatsChartOutline,
  Chart2Fill: IoStatsChart,
  Brands: IoPricetagsOutline,
  BrandsFill: IoPricetags,
  Business: IoBusinessOutline,
  BusinessFill: IoBusiness,
  CheckCircle: IoCheckmarkDoneCircleOutline,
  ArrowRight: IoArrowForward,
  ArrowDown: IoArrowDown,
  WalletIcon: IoWalletOutline,
  Exchange: IoSwapHorizontalOutline,
  PlusOutline: IoAddOutline,
  MinusOutline: IoRemoveOutline,
  UnCheckedCircle: IoEllipseOutline,
  LayoutIcon: IoGridOutline,
  LayoutFillIcon: IoGrid,
  Refund: IoRepeatOutline,
  RefundFill: IoRepeat,
  State: IoSwapVerticalOutline,
  Document: IoDocumentOutline,
  Edit: IoPencilOutline,
  Delete: IoTrashOutline,
  Copy: IoCopyOutline,
  OpenLink: IoOpenOutline,
  Upload: IoCloudUploadOutline,
  UploadTray: IoShareOutline,
  Truck: IoCarSportOutline,
  Packages: TbPackages,
  Bin: TbBox,
  Carton: TbPackage,
  ShippingCompany: TbPlaneDeparture,
  ShippingCompanyFill: TbPlaneDeparture,
  Receiving: TbTruckDelivery,
  ReceivingFill: TbTruckDelivery,
  DragHandle: MdDragIndicator,
  Sorting: TbArrowsSort,
  SortingFill: TbArrowsSort,
  Repackaging: TbPackageExport,
  RepackagingFill: TbPackageExport,
  Categories: BiCategoryAlt,
  ActiveCategories: BiSolidCategoryAlt,
  Watcher: TbSettingsAutomation,
  WatcherFill: TbSettingsAutomation,
  Briefcase: IoBriefcaseOutline,
  BriefcaseFill: IoBriefcase,
  Undo: IoArrowUndoOutline,
  Shield: IoShieldCheckmarkOutline,
  Flag: IoFlagOutline,
  Camera: IoCameraOutline,
  CardOutline: IoCardOutline,
  Link: IoLinkOutline,
  Brush: IoBrushOutline,
  Square: IoSquareOutline,
  DrawPolygon: FaDrawPolygon,
  Eraser: FaEraser,
  Expand: IoExpandOutline,
  Contract: IoContractOutline,
  Tree: PiTreeStructure,
  Complaint: IoMegaphoneOutline,
  ComplaintFill: IoMegaphone,
  Ban: IoBanOutline,
  Send: IoSendOutline,
};
